import React from 'react';
import styled from '@emotion/styled';

import { mq, text } from '../../../_style';

import columnData from '../../../assets/data/column.json';

import ColumnSlider from '../columnSlider';
import ContentWidth from '../contentWidth';

const Aside = styled.aside`
  margin-bottom: 90px;
`;
const AsideHeading = styled.h3`
  ${text('26px', 1)}
  text-align: center;
  ${mq.pc} {
    margin-bottom: 60px;
  }
  ${mq.sp} {
    margin-bottom: 45px;
  }
`;

const ArticleBody = (props) => {
  return(
    <Aside>
      <ContentWidth>
        <AsideHeading>その他コラム</AsideHeading>
        <ColumnSlider items={columnData}></ColumnSlider>
      </ContentWidth>
    </Aside>
  );
};
export default ArticleBody;
